export default __webpack_public_path__ + "static/media/bootstrap-icons.cc252f2c.woff";